<template>
  <TeamsOverview action-id="pw" :per-page="25">
    <template v-slot="{ row }">
      <div class="col-12 mb-4">
        <div class="kotk-team kotk-team--pw-team view-mode--teaser" :data-id="row.drupal_internal__id">
          <div class="teaser">
            <a :href="[path, row.id].join('/')" class="teaser__url">
              <div class="teaser__content">
                <div class="teaser__title">{{ row.label }}</div>
<!--                <div class="teaser__location">Ergens, Belgium</div>-->
<!--                <div class="teaser__runners"></div>-->
              </div>
            </a>
          </div>
        </div>
      </div>
    </template>
  </TeamsOverview>
</template>

<script>
import TeamsOverview from "@/components/Views/TeamsOverview.vue";

export default {
  name: "PwTeamsOverview",
  components: {
    TeamsOverview,
  },
  data() {
    return {
      path: this.$window.location.pathname,
    }
  }
}
</script>
